import React, { useEffect, useRef, useState } from "react";
import CategoryCard from "./CategoryCard";

export default function RootCategoriesSection({
  rootCategories = [],
  loadingCategory = false,
}) {
  const carouselRef = useRef(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  // موبایل: 4 کارت با gap-3
  // دسکتاپ (lg به بالا): 8 کارت با gap-4
  const categoryItemClassName =
    "w-[calc((100%-2.25rem)/4)] min-w-[calc((100%-2.25rem)/4)] " +
    "lg:w-[calc((100%-7rem)/8)] lg:min-w-[calc((100%-7rem)/8)]";

  // بررسی اینکه آیا دسته‌ها به اسکرول افقی نیاز دارند یا نه
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel || loadingCategory) return;

    const checkOverflow = () => {
      // عدد 1 برای جلوگیری از خطای اعشاری احتمالی در عرض‌ها است
      setHasOverflow(carousel.scrollWidth > carousel.clientWidth + 1);
    };

    const frameId = requestAnimationFrame(checkOverflow);

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(carousel);

    return () => {
      cancelAnimationFrame(frameId);
      resizeObserver.disconnect();
    };
  }, [rootCategories, loadingCategory]);

  // حرکت به اندازه یک کارت + فاصله بین کارت‌ها
  const scrollByCategory = (direction) => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const firstCard = carousel.querySelector("[data-category-card]");
    if (!firstCard) return;

    const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
    const scrollAmount = (firstCard.offsetWidth + gap) * direction;

    carousel.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <section className="px-2 py-4 sm:px-5 sm:py-5">
      {loadingCategory ? (
        <div
          className="flex w-full gap-2 overflow-x-auto scroll-smooth sm:gap-3 lg:gap-4"
          style={{
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {[...Array(8)].map((_, index) => (
            <div
              key={index}
              aria-hidden="true"
              className={`${categoryItemClassName} shrink-0 aspect-[0.9] animate-pulse rounded-2xl border border-gray-200 bg-gray-50`}
            />
          ))}
        </div>
      ) : rootCategories.length > 0 ? (
        <div className="relative">
          <div
            ref={carouselRef}
            className="
              no-scrollbar
              flex w-full snap-x snap-mandatory gap-2
              overflow-x-auto scroll-smooth
              sm:gap-3
              lg:gap-4
            "
            style={{
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {rootCategories.map((category) => (
              <div
                key={category.id}
                data-category-card
                className={`${categoryItemClassName} snap-start shrink-0`}
              >
                <CategoryCard
                  category={category}
                  className="w-full min-w-0"
                />
              </div>
            ))}
          </div>

          {/* دکمه‌ها فقط روی دسکتاپ و فقط در حالت overflow نمایش داده می‌شوند */}
          {hasOverflow && (
            <>
              <button
                type="button"
                onClick={() => scrollByCategory(-1)}
                className="
                  absolute left-2 top-1/2 z-10
                  hidden h-10 w-10 -translate-y-1/2
                  items-center justify-center rounded-full
                  border border-gray-300 bg-white/95
                  text-[#1E3A5F] shadow-sm backdrop-blur
                  transition-all duration-200
                  hover:border-[#1E3A5F] hover:bg-gray-50
                  lg:flex
                "
                aria-label="دسته‌های قبلی"
              >
                <svg
                  className="h-5 w-5 rotate-180"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>

              <button
                type="button"
                onClick={() => scrollByCategory(1)}
                className="
                  absolute right-2 top-1/2 z-10
                  hidden h-10 w-10 -translate-y-1/2
                  items-center justify-center rounded-full
                  border border-gray-300 bg-white/95
                  text-[#1E3A5F] shadow-sm backdrop-blur
                  transition-all duration-200
                  hover:border-[#1E3A5F] hover:bg-gray-50
                  lg:flex
                "
                aria-label="دسته‌های بعدی"
              >
                <svg
                  className="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </>
          )}
        </div>
      ) : (
        <div className="py-10 text-center text-sm text-gray-500">
          دسته‌بندی‌ای یافت نشد
        </div>
      )}
    </section>
  );
}
